export const sweMobilePhoneNumberRegex = /^((([+]|00)46)|0)(7[0236])(\d{7})$/;

export const validPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
export const validPasswordDescription =
  'Lösenordet måste vara minst 6 tecken långt, innehålla minst en stor bokstav, en liten bokstav och en siffra.';
